export const getRequestUrl = (
  url,
  // eslint-disable-next-line
  domain = __NEW__PHP_DOMAIN__,
  useDefaultPort = false
) => {
  const { port } = window.location
  // 开发模式下走代理
  if (__DEV__) return url

  if (port == 80 || port == '' || useDefaultPort) {
    return `${domain}${url}`
  }

  return `${domain}:${port}${url}`
}
